var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"icon":"sad-cry","title":"Page Not Found"}},[_c('div',{staticClass:"box p-3"},[_c('p',[_vm._v("Whoops looks like we having troubling finding the page you're after.")]),_c('router-link',{staticClass:"button is-info mt-2",attrs:{"to":{ name: 'dashboard' }}},[_c('icon',{attrs:{"icon":"home"}}),_c('span',[_vm._v("Go Home")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }